import { z } from "zod";

/**
 * `COVERAGE-READ-CHECK` (`P0-DOS-066`): **the `details` of `POST /api/v1/dossiers/{id}/submissions`' `409 stage_guard_failed` when the guard is `couverture_pieces`** (A48: the door and its clients
 * speak one shape). The error's `message` is the chargée's sentence, one per short pièce; each short pièce also carries, in `pieces[].clientSentence`, the sentence the CLIENT reads, served so that the
 * console prefills it and no browser composes a sentence from months. Strict: an extra key is a mismatch.
 */
export const coverageGateDetailsSchema = z.strictObject({
  guard: z.literal("couverture_pieces"),
  pieces: z
    .array(
      z.strictObject({
        code: z.enum(["bulletinsSalaire", "relevesBancaires"]),
        /** `AAAA-MM`, oldest first. */
        missingMonths: z.array(z.string().regex(/^\d{4}-\d{2}$/u)).min(1),
        /** « Les bulletins de salaire envoyés ne couvrent pas août 2026 : ajoutez le document de ce mois. » */
        clientSentence: z.string().min(1),
      }),
    )
    .min(1),
});
export type CoverageGateDetails = z.infer<typeof coverageGateDetailsSchema>;
